import LandingPage from "./LandingPage";
import "./index.css";

export default function App() {
  return (
    <div className=" w-full p-[16px] ">
      <LandingPage />
    </div>
  );
}
